import PropTypes from 'prop-types';

const questionGroupPropType = PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    groupOrder: PropTypes.number,
});

export default questionGroupPropType;
